// Our bootleg way of adding entries. Too lazy to make a backend, not lazy enough to build an entry from an object

const templateCard = {
    cardName: {
      title:``,
      thumbnail:``,
      image:``,
      link:``,
      description:``
    }
  };

export const profWork = {
  Banners:{
    type: `gallery`,
    title: `Banner Work for Positive Promotions`,
    thumbnail: `/images/projects/Banners_Thumb.jpg`, //https://placehold.co/576X324
    image: `/images/projects/Banners_Thumb.jpg`,
    images: {
      banner1: {
       description: `Category banner done for our 2024 holiday event.`,
       image: `/images/projects/posipromo/tlvlhol-XL.jpg`
      },
      banner2: {
        description: `Category banner done for our 2024 nursing assistants event.`,
        image: `/images/projects/posipromo/hlchealthcarehospitalrecognition-XL.jpg`
      },
      banner3: {
        description: `Category banner done for our 2024 rehabiliation therapy event.`,
        image: `/images/projects/posipromo/tlvlhlc_1001_204-XL.jpg`
      },
      banner4: {
        description: `Category banner done for our 2024 nursing assistants event.`,
        image: `/images/projects/posipromo/nursing_assistants.jpg`
      },
    }
  },
  LPBCA:{
    type: `standard`,
    title: `Breast Cancer Awareness Landing Page`,
    thumbnail: `/images/projects/BreastCancerAwareness_Thumb.jpg`,
    image: `/images/projects/BreastCancerAwareness_Thumb.jpg`,
    link: `https://www.positivepromotions.com/breast-cancer-awareness-promotional-products/c/tmp-bcam/`,
    description: `A landing page did code and graphic art for, for Positive Promotions breast cancer awareness product event.`
  },
  LPWS:{
    type: `standard`,
    title: `Workplace Safety Landing Page`,
    thumbnail: `/images/projects/WorkPlaceSafety_Thumb.jpg`,
    image: `/images/projects/WorkPlaceSafety_Thumb.jpg`,
    link: `https://www.positivepromotions.com/workplace-safety/c/tmp-workplacesafety/`,
    description: `A landing page did code and graphic art for, for Positive Promotions workplace safety product event.`
  },

};

export const animationFolders = {
    TS2: {
      type: `standard`,
      title: `Toy Story 2: Reanimated Collab`,
      thumbnail: `/images/projects/ToyStory_2_Reanimated.jpg`,
      image: `/images/projects/ToyStory_2_Reanimated.jpg`,
      link: `https://www.youtube.com/watch?v=pe9OyJEpEPQ`,
      description: `This was a volunteer group project between an assortment of online animators to animate beloved scenes of the "Toy Story 2" movie in our image. 
      The scene I chose to reanimate was the moment in the film when the plane is taking off as Woody makes his escape. This was a first for a lot of things as I have 
      never blended together 2D animation and 3D. As well as being the truly first composited animation I have ever done.`
    },
    JtP: {
      type: `standard`,
      title: `Joshua and the Promise Land: Reanimated Collab`,
      thumbnail: `/images/projects/Joshua_Reanimated.png`,
      image: `/images/projects/Joshua_Reanimated.png`,
      link: `https://www.youtube.com/watch?v=tQYU8nrmFs4`,
      description: `This was a volunteer group project between an assortment of online animators to animate scenes from a lesser known religiously motivated film known 
      as "Joshua and the Promise Land". The project was headed by Saberspark, a youtube content creator. The scene I chose, although short, had me foaming at the mouth with ideas. 
      At the time I had start familiarizing myself with Clip Studio Paint's animation suite, so for this project I knew I wanted to test out rendering and tweening. 
      I kept the scene simple with an emphasis on small movement and a heavy hand on rendering.`
    },
    SSMR: {
      type: `standard`,
      title: `The Spongebob Squarepants Movie Reanimated Collab`,
      thumbnail: `/images/projects/Spongebob_Reanimated.jpg`,
      image: `/images/projects/Spongebob_Reanimated.jpg`,
      link: `https://www.youtube.com/watch?v=xN9R_U7uLmU`,
      description: `This was a volunteer group project between an assortment of online animators to animate beloved scenes of the "The Spongebob Squarepants Movie (2004)" 
      in our image. This was the very first animation jam I had ever participated in. It was also the first time I used something other that Adobe Flash to animate in. 
      I chose this scene for it's simplicity and meme value. The anglerfish runcycle, and honestly the movement ingeneral in that scene, seemed to easy to exploit do get 
      some dank memes on there. It also was a good time to really deep dive and test out Clip Studio Paint's animation suite. It was rough having to leave the comfort of 
      Adobe's Flash, but whooooo boy those prices were not in my budget at the time. `
    },
  };
  
  export const gameFolders = {
    DFF: {
      type: `standard`,
      title: `Demon Flesh Factory`,
      thumbnail: `/images/projects/Demon_Flesh_Factory.png`,
      image: `/images/projects/Demon_Flesh_Factory.png`,
      link: `https://blazinmeow.itch.io/demon-flesh-factory`,
      description: ``
    },
    GoE: {
      type: `standard`,
      title: `Garden of Eden`,
      thumbnail: `/images/projects/Garden_of_Eden.png`,
      image: `/images/projects/Garden_of_Eden.png`,
      link: `https://nerdspartan.itch.io/garden-of-eden`,
      description: ``
    },
    KA: {
      type: `standard`,
      title: `Kaiju Architect`,
      thumbnail: `/images/projects/Kaiju.png`,
      image: `/images/projects/Kaiju.png`,
      link: `https://blazinmeow.itch.io/kaiju-architect`,
      description: ``
    }
  };